import { useEffect, useRef } from 'react'

export const useReadyTitleBlinking = () => {
  const notificationIntervalRef = useRef<number | null>(null)

  const blinkNotification = (originalTitle: string) => {
    const isNotificationVisible = document.title !== originalTitle
    document.title = isNotificationVisible
      ? originalTitle
      : `[Ready] - ${originalTitle}`
  }

  const stopBlinking = (originalTitle: string) => {
    if (notificationIntervalRef.current) {
      clearInterval(notificationIntervalRef.current)
    }
    document.title = originalTitle
  }

  const startReadyTitleBlinking = () => {
    if (!document.hidden) {
      console.log('Page is already visible, skipping notification')
      return
    }
    const originalTitle = document.title

    if (notificationIntervalRef.current) {
      clearInterval(notificationIntervalRef.current)
    }

    notificationIntervalRef.current = window.setInterval(() => {
      blinkNotification(originalTitle)
    }, 1000)

    const stopNotificationHandler = () => {
      if (!document.hidden) {
        stopBlinking(originalTitle)
        window.removeEventListener('focus', stopNotificationHandler)
      }
    }

    window.addEventListener('focus', () => stopNotificationHandler())
  }

  useEffect(() => {
    return () => {
      if (notificationIntervalRef.current) {
        clearInterval(notificationIntervalRef.current)
      }
    }
  }, [])

  return { startReadyTitleBlinking }
}
